import z from 'zod';

const formFieldOptionSchema = z
	.object({
		value: z.union([z.string(), z.number()]).transform(String),
		label: z.string(),
		text: z.string().optional(),
		group: z.string().nullable().optional(),
	})
	.transform((option) => ({
		value: option.value,
		label: option.label,
		text: option.text ?? option.label,
		group: option.group ?? null,
	}));

export const formFieldValueSchema = z.object({
	alias: z.string(),
	value: z.string(),
});

export const formFieldSchema = z.object({
	alias: z.string(),
	help: z
		.string()
		.nullish()
		.transform((value) => value ?? ''),
	label: z.string(),
	lockIfFilled: z.boolean().optional().default(false),
	options: z.array(formFieldOptionSchema).nullable(),
	type: z.enum(['text', 'select', 'radio', 'checkbox']),
	value: z
		.union([z.string(), z.number(), z.null(), z.undefined()])
		.transform((value) => (value == null ? '' : String(value))),
});
